import React from 'react';
import PropTypes from 'prop-types';

const PERIODS = [
  { label: '7日', value: 7 },
  { label: '30日', value: 30 },
  { label: '90日', value: 90 },
];

const PeriodSelector = ({ value, onChange }) => (
  <div className="o-period-selector">
    {PERIODS.map((period) => (
      <button
        type="button"
        key={period.value}
        className={`o-period-selector__button${value === period.value ? ' o-period-selector__button--active' : ''}`}
        onClick={() => onChange(period.value)}
      >
        {period.label}
      </button>
    ))}
  </div>
);

PeriodSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PeriodSelector;
